import Vue from "vue";
// import Vuetify from "vuetify/lib";
// import "vuetify/dist/vuetify.min.css";

import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";
import fr from "vuetify/es5/locale/fr";

const options = {
  theme: {
    themes: {
      light: {
        primary: "#884AFF",
        secondary: "#424242",
        accent: "#82B1FF",
        error: "#FF5252",
        info: "#acacac",
        success: "#4CAF50",
        warning: "#FFC107",
        indigo: "#5b53ff",
        primarylight: "#b68ff1"
      }
    }
  },
  customProperties: true,
  iconfont: "mdi",
  lang: {
    locales: { fr },
    current: "fr"
  }
};

Vue.use(Vuetify, options);

export default new Vuetify(options);
